var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategorySalads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_7549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0587 112.544C62.6763 112.544 51.3125 110.711 42.4116 107.654C43.6922 112.719 46.0981 116.55 49.0646 117.776C55.7599 120.543 64.9354 122.249 75.0587 122.249C85.1819 122.249 94.3575 120.543 101.053 117.776C104.019 116.55 106.425 112.719 107.706 107.654C98.8049 110.711 87.441 112.544 75.0587 112.544Z",
    fill: "url(#paint0_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.059 64.7047C150.059 43.8588 0.0588379 43.8588 0.0588379 64.7047C0.0588379 85.5506 17.6844 116.119 75.0588 116.119C132.433 116.119 150.059 85.5509 150.059 64.7047Z",
    fill: "url(#paint1_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.059 64.7047C150.059 85.5506 0.0588379 85.5506 0.0588379 64.7047C0.0588379 43.8588 150.059 43.8588 150.059 64.7047Z",
    fill: "url(#paint2_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.177 49.5989C129.177 71.8698 24.9457 71.8698 24.9457 49.5989C24.9457 45.7589 28.046 42.5818 33.1751 40.0662C35.0383 39.1524 36.7569 37.6692 38.1936 35.6577L38.3477 35.4421C41.4719 31.0686 45.9951 29.8412 49.9313 32.2989L49.9342 32.3006C53.2969 34.4003 57.1307 33.8356 60.1613 30.7945L60.4495 30.505C63.7916 27.1515 68.0892 26.8765 71.6069 29.7906L71.8757 30.0133C75.1066 32.6898 79.0183 32.6903 82.2495 30.0145L82.5201 29.7903C86.0383 26.8768 90.336 27.153 93.678 30.5071L94.0277 30.858C97.0416 33.8827 100.858 34.4242 104.192 32.3003C108.099 29.8109 112.61 31.01 115.72 35.3648L115.929 35.6577C117.366 37.6692 119.085 39.1527 120.947 40.0662C126.077 42.5818 129.177 45.7592 129.177 49.5989Z",
    fill: "url(#paint3_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.857 41.7529C109.854 41.7529 107.42 44.187 107.42 47.19C107.42 50.1929 109.854 52.627 112.857 52.627C115.86 52.627 118.294 50.1929 118.294 47.19C118.294 44.187 115.86 41.7529 112.857 41.7529ZM112.857 49.4979C111.582 49.4979 110.549 48.4647 110.549 47.19C110.549 45.9153 111.582 44.882 112.857 44.882C114.132 44.882 115.165 45.9153 115.165 47.19C115.165 48.4647 114.132 49.4979 112.857 49.4979Z",
    fill: "url(#paint4_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9976 31.3153C67.9947 31.3153 65.5605 33.7494 65.5605 36.7524C65.5605 39.7553 67.9947 42.1894 70.9976 42.1894C74.0002 42.1894 76.4347 39.7553 76.4347 36.7524C76.4347 33.7494 74.0005 31.3153 70.9976 31.3153ZM70.9976 39.06C69.7229 39.06 68.6897 38.0268 68.6897 36.7521C68.6897 35.4774 69.7229 34.4441 70.9976 34.4441C72.2723 34.4441 73.3055 35.4774 73.3055 36.7521C73.3055 38.0268 72.2723 39.06 70.9976 39.06Z",
    fill: "url(#paint5_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.697 61.6219C108.308 61.6219 112.857 57.0729 112.857 51.4616C112.857 45.8502 108.308 41.3013 102.697 41.3013C97.0853 41.3013 92.5364 45.8502 92.5364 51.4616C92.5364 57.0729 97.0853 61.6219 102.697 61.6219Z",
    fill: "url(#paint6_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8363 64.7941L68.5863 33.5274C66.6304 31.5715 64.3054 30.8 61.863 29.9274C61.366 30.2744 60.9142 30.0385 60.4495 30.505L60.1613 30.7944C57.1304 33.8356 53.2966 34.4003 49.9342 32.3006L49.9313 32.2988C48.688 31.5227 47.6804 31.5665 46.3828 31.5085C45.2904 32.2047 44.3063 32.8603 43.3525 33.8141C36.2889 40.8777 35.9427 52.0438 43.0063 59.1077L47.5442 63.6456C62.8657 66.7494 83.2625 67.1327 99.8363 64.7941Z",
    fill: "url(#paint7_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.865 64.7047C143.865 80.0674 6.25232 80.0674 6.25232 64.7047C6.25232 49.3421 143.865 49.3424 143.865 64.7047Z",
    fill: "url(#paint8_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9389 76.7827C2.90096 79.8924 4.25684 83.0448 6.06096 86.143C31.8613 97.4021 118.256 97.4021 144.057 86.143C145.861 83.0448 147.217 79.8924 148.179 76.7827C128.268 91.0583 21.8498 91.0583 1.9389 76.7827Z",
    fill: "url(#paint9_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.791 64.1062C143.647 65.1238 143.274 66.1121 142.697 67.068C140.473 69.2283 135.197 71.0065 127.949 72.4024C123.995 73.1638 119.455 72.3409 114.504 72.8747C110.014 73.3588 105.185 75.22 100.149 75.5171C92.4188 75.973 84.1988 76.2088 75.9618 76.2238C68.6676 76.2415 52.9323 73.3768 52.7853 71.9886C52.4059 68.415 54.8029 65.1709 59.0353 62.3562C59.5029 62.0474 59.9559 61.6886 60.3853 61.2827C61.3706 60.3562 62.2529 59.1856 62.9882 57.7915L63.1 57.5768C64.2382 55.4209 65.75 53.9503 67.4353 53.2444C68.8853 52.6385 70.4618 52.6033 72.0382 53.1915C72.3294 53.3003 72.6206 53.4297 72.9088 53.5827L72.9118 53.5856C75.2382 54.8033 77.65 54.6356 79.697 53.2062C80.4147 52.7062 81.0882 52.0474 81.6971 51.2415L81.9206 50.9444C84.5118 47.515 88.2382 46.8621 91.5971 49.2503L91.8529 49.4327C94.9382 51.6268 98.3559 51.268 100.915 48.4797L101.129 48.2444C103.915 45.2091 107.697 45.0709 110.944 47.8856L111.285 48.1797C114.215 50.718 117.6 50.8709 120.306 48.5856C121.585 47.5062 123.009 46.9738 124.459 46.9738C126.6 46.9738 128.8 48.1297 130.676 50.3768L130.885 50.6297C132.338 52.368 133.985 53.5915 135.703 54.2709C140.429 56.1385 143.45 58.8121 143.826 62.3856C143.888 62.968 143.876 63.5444 143.791 64.1062Z",
    fill: "url(#paint10_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5861 33.5274C61.5226 26.4639 50.07 26.4639 43.0061 33.5274C35.9423 40.5909 35.9426 52.0436 43.0061 59.1074C50.0697 66.1709 61.5223 66.1709 68.5861 59.1074C75.65 52.0439 75.65 40.5912 68.5861 33.5274ZM47.6744 54.4394C43.1894 49.9544 43.1894 42.6806 47.6744 38.1956C52.1594 33.7106 59.4314 33.7124 63.9164 38.1974C68.4014 42.6824 68.4032 49.9544 63.9182 54.4394C59.4332 58.9244 52.1594 58.9244 47.6744 54.4394Z",
    fill: "url(#paint11_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1574 56.9565C51.0324 62.8315 60.5603 62.8315 66.4353 56.9565C72.3121 51.0797 72.3103 41.5536 66.4353 35.6786C60.5586 29.8018 51.0342 29.8018 45.1574 35.6786C39.2824 41.5533 39.2806 51.0797 45.1574 56.9565ZM63.9183 38.1953C68.4033 42.6803 68.4033 49.9542 63.9183 54.4392C59.4333 58.9242 52.1612 58.9224 47.6762 54.4374C43.1912 49.9524 43.1895 42.6803 47.6745 38.1953C52.1595 33.7103 59.4333 33.7103 63.9183 38.1953Z",
    fill: "url(#paint12_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.694 42.0065C132.044 36.3565 122.883 36.3565 117.233 42.0065C111.583 47.6565 111.583 56.8171 117.233 62.4671C122.883 68.1171 132.044 68.1171 137.694 62.4671C143.344 56.8171 143.344 47.6565 137.694 42.0065ZM120.967 58.7333C117.379 55.146 117.379 49.3277 120.967 45.7404C124.554 42.153 130.371 42.1545 133.958 45.7418C137.546 49.3292 137.547 55.146 133.96 58.7333C130.372 62.3207 124.554 62.3207 120.967 58.7333Z",
    fill: "url(#paint13_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.954 60.7465C123.653 65.4456 131.274 65.4456 135.973 60.7465C140.674 56.0459 140.672 48.4262 135.973 43.7271C131.273 39.0265 123.654 39.0265 118.954 43.7271C114.255 48.4262 114.253 56.0459 118.954 60.7465ZM133.96 45.7403C137.547 49.3277 137.547 55.1459 133.96 58.7333C130.373 62.3206 124.556 62.3192 120.968 58.7318C117.381 55.1445 117.38 49.3277 120.967 45.7403C124.554 42.153 130.373 42.153 133.96 45.7403Z",
    fill: "url(#paint14_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2575 36.7516C87.0346 36.7266 87.6446 36.0766 87.6196 35.2992C87.5946 34.5221 86.9446 33.9121 86.1672 33.9371C85.3902 33.9621 84.7802 34.6121 84.8052 35.3895C84.8302 36.1666 85.4805 36.7766 86.2575 36.7516Z",
    fill: "url(#paint15_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7199 39.3881C79.7081 39.0181 79.3987 38.7278 79.0287 38.7399C78.6587 38.7516 78.3687 39.061 78.3805 39.431C78.3922 39.801 78.7019 40.091 79.0717 40.0793C79.4417 40.0672 79.7319 39.7578 79.7199 39.3881Z",
    fill: "url(#paint16_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3879 39.0333C88.2132 38.7072 87.807 38.5842 87.4808 38.7589C87.1547 38.9336 87.0317 39.3398 87.2064 39.666C87.3811 39.9922 87.7873 40.1151 88.1135 39.9404C88.4397 39.766 88.5626 39.3598 88.3879 39.0333Z",
    fill: "url(#paint17_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7978 36.4359C93.6231 36.1097 93.2169 35.9868 92.8908 36.1615C92.5646 36.3362 92.4416 36.7424 92.6163 37.0686C92.7911 37.3947 93.1972 37.5177 93.5234 37.343C93.8496 37.1683 93.9725 36.7621 93.7978 36.4359Z",
    fill: "url(#paint18_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0912 41.2709C79.7021 40.848 79.0441 40.8207 78.6212 41.2098C78.1982 41.5989 78.1709 42.2568 78.56 42.6798C78.9491 43.1027 79.6071 43.1301 80.03 42.7409C80.453 42.3518 80.4803 41.6936 80.0912 41.2709Z",
    fill: "url(#paint19_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4988 36.7572C83.1917 36.4234 82.672 36.4016 82.3382 36.709C82.0043 37.016 81.9826 37.5357 82.2899 37.8696C82.597 38.2034 83.1167 38.2252 83.4505 37.9178C83.7841 37.6107 83.8058 37.091 83.4988 36.7572Z",
    fill: "url(#paint20_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7917 33.8201C90.4847 33.4863 89.9649 33.4645 89.6311 33.7718C89.2973 34.0789 89.2755 34.5986 89.5829 34.9324C89.8899 35.2663 90.4097 35.288 90.7435 34.9807C91.077 34.6736 91.0988 34.1539 90.7917 33.8201Z",
    fill: "url(#paint21_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6454 38.8828C84.8304 39.0839 85.144 39.0972 85.3451 38.9119C85.5463 38.7266 85.5596 38.4133 85.3743 38.2122C85.189 38.011 84.8757 37.9978 84.6746 38.183C84.4731 38.3683 84.4601 38.6816 84.6454 38.8828Z",
    fill: "url(#paint22_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7552 40.4306C83.7222 34.3976 73.9405 34.3976 67.9075 40.4306C61.8746 46.4635 61.8746 56.2453 67.9075 62.2782C73.9405 68.3112 83.7222 68.3112 89.7552 62.2782C95.7881 56.2453 95.7881 46.4635 89.7552 40.4306ZM71.8943 58.2912C68.0637 54.4606 68.0637 48.2479 71.8943 44.4174C75.7249 40.5868 81.9361 40.5882 85.7666 44.4188C89.5972 48.2494 89.5987 54.4606 85.7681 58.2912C81.9375 62.1218 75.7249 62.1218 71.8943 58.2912Z",
    fill: "url(#paint23_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7447 60.4408C74.7624 65.4585 82.9003 65.4585 87.918 60.4408C92.9371 55.4217 92.9356 47.2853 87.918 42.2676C82.8986 37.2482 74.7639 37.2482 69.7447 42.2676C64.7271 47.2853 64.7253 55.4217 69.7447 60.4408ZM85.7683 44.4173C89.5989 48.2479 89.5989 54.4605 85.7683 58.2911C81.9377 62.1217 75.7265 62.1203 71.8959 58.2897C68.0653 54.4591 68.0638 48.2479 71.8944 44.4173C75.725 40.5867 81.9377 40.5867 85.7683 44.4173Z",
    fill: "url(#paint24_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4827 62.6615C59.8095 72.2865 24.9542 62.6056 27.6277 52.9806C30.3013 43.3556 40.2707 37.7203 49.8957 40.3935C59.5207 43.0668 65.1563 53.0365 62.4827 62.6615Z",
    fill: "url(#paint25_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78 37.9762C118.717 30.9127 107.264 30.9127 100.2 37.9762C93.1366 45.0398 93.1369 56.4924 100.2 63.5562C107.264 70.6198 118.717 70.6198 125.78 63.5562C132.844 56.4927 132.844 45.0398 125.78 37.9762ZM104.869 58.888C100.384 54.403 100.384 47.1292 104.869 42.6442C109.354 38.1592 116.626 38.1609 121.111 42.6459C125.596 47.1309 125.598 54.403 121.113 58.888C116.628 63.373 109.354 63.373 104.869 58.888Z",
    fill: "url(#paint26_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.352 61.4051C108.227 67.2801 117.755 67.2801 123.63 61.4051C129.506 55.5284 129.505 46.0022 123.63 40.1272C117.753 34.2504 108.229 34.2504 102.352 40.1272C96.4767 46.0022 96.475 55.5284 102.352 61.4051ZM121.113 42.6442C125.598 47.1292 125.598 54.4031 121.113 58.8881C116.628 63.3731 109.356 63.3713 104.871 58.8863C100.386 54.4013 100.384 47.1292 104.869 42.6442C109.354 38.1592 116.628 38.1592 121.113 42.6442Z",
    fill: "url(#paint27_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4948 42.4974C29.4657 36.4683 19.6901 36.4683 13.661 42.4974C7.63188 48.5265 7.63188 58.3021 13.661 64.3312C19.6901 70.3604 29.4657 70.3604 35.4948 64.3312C41.5239 58.3021 41.5239 48.5265 35.4948 42.4974ZM17.6454 60.3468C13.8172 56.5186 13.8172 50.3101 17.6454 46.4818C21.4736 42.6536 27.6807 42.6551 31.5089 46.4833C35.3372 50.3115 35.3387 56.5186 31.5104 60.3468C27.6822 64.1751 21.4734 64.1751 17.6454 60.3468Z",
    fill: "url(#paint28_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4969 62.4954C20.5114 67.5098 28.6443 67.5098 33.6587 62.4954C38.6749 57.4793 38.6731 49.3481 33.6587 44.3337C28.6425 39.3175 20.5128 39.3175 15.4969 44.3337C10.4825 49.3481 10.4808 57.4793 15.4969 62.4954ZM31.5105 46.4819C35.3387 50.3101 35.3387 56.5187 31.5105 60.3469C27.6822 64.1751 21.4752 64.1737 17.6469 60.3454C13.8187 56.5172 13.8172 50.3101 17.6455 46.4819C21.4737 42.6537 27.6822 42.6537 31.5105 46.4819Z",
    fill: "url(#paint29_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.791 64.1062C143.647 65.1238 143.274 66.1121 142.697 67.068C140.47 69.2306 135.185 71.0103 127.924 72.4068C123.741 73.2115 118.903 72.1241 113.616 72.6744C109.377 73.1156 104.851 75.2397 100.143 75.5174C92.4141 75.9733 84.1965 76.2085 75.9618 76.2238C68.6676 76.2415 52.9323 73.3768 52.7853 71.9886C52.4059 68.415 54.8029 65.1709 59.0353 62.3562C59.5029 62.0474 59.9559 61.6886 60.3853 61.2827C61.3706 60.3562 62.2529 59.1856 62.9882 57.7915L63.1 57.5768C64.2382 55.4209 65.75 53.9503 67.4353 53.2444C68.8853 52.6385 70.4618 52.6033 72.0382 53.1915C72.3294 53.3003 72.6206 53.4297 72.9088 53.5827L72.9118 53.5856C75.2382 54.8033 77.65 54.6356 79.697 53.2062C80.4147 52.7062 81.0882 52.0474 81.6971 51.2415L81.9206 50.9444C84.5118 47.515 88.2382 46.8621 91.5971 49.2503L91.8529 49.4327C94.9382 51.6268 98.3559 51.268 100.915 48.4797L101.129 48.2444C103.915 45.2091 107.697 45.0709 110.944 47.8856L111.285 48.1797C114.215 50.718 117.6 50.8709 120.306 48.5856C121.585 47.5062 123.009 46.9738 124.459 46.9738C126.6 46.9738 128.8 48.1297 130.676 50.3768L130.885 50.6297C132.338 52.368 133.985 53.5915 135.703 54.2709C140.429 56.1385 143.45 58.8121 143.826 62.3856C143.888 62.968 143.876 63.5444 143.791 64.1062Z",
    fill: "url(#paint30_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2869 75.8836C75.4069 76.0345 75.438 76.0739 75.558 76.2245C83.9151 76.2165 92.2622 75.9815 100.107 75.5198C105.016 75.2306 109.728 73.6765 114.122 73.2098C119.213 72.6692 123.877 73.1859 127.926 72.4068C135.186 71.0104 140.47 69.2306 142.697 67.0683C143.273 66.1124 143.647 65.1242 143.791 64.1065C143.876 63.5448 143.888 62.9683 143.826 62.3859C143.812 62.2533 143.795 62.1221 143.773 61.9921C143.287 59.0112 140.73 56.8812 137.732 56.5198C136.33 56.3509 134.918 55.6933 133.598 54.5495L133.257 54.2554C130.01 51.4407 126.227 51.5789 123.442 54.6142L123.227 54.8495C120.668 57.6377 117.251 57.9965 114.165 55.8024L113.91 55.6201C110.551 53.2318 106.824 53.8848 104.233 57.3142L104.01 57.6112C103.401 58.4171 102.727 59.0759 102.01 59.5759C99.9625 61.0054 97.5507 61.173 95.2242 59.9554L95.2213 59.9524C94.9331 59.7995 94.6419 59.6701 94.3507 59.5612C92.7742 58.973 91.1978 59.0083 89.7478 59.6142C88.0625 60.3201 86.5507 61.7906 85.4125 63.9465L85.3007 64.1612C84.5654 65.5554 83.683 66.7259 82.6977 67.6524C82.2683 68.0583 81.8154 68.4171 81.3477 68.7259C78.1151 70.8756 75.958 73.2768 75.2869 75.8836Z",
    fill: "url(#paint31_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.839 73.6895C111.603 74.3183 106.348 74.7477 100.119 75.5177C92.3979 75.9724 84.1885 76.2074 75.9618 76.2239C68.6676 76.2415 52.9323 73.3768 52.7853 71.9886C52.4059 68.415 54.8029 65.1709 59.0353 62.3562C59.5029 62.0474 59.9559 61.6886 60.3853 61.2827C61.3706 60.3562 62.2529 59.1856 62.9882 57.7915L63.1 57.5768C64.2382 55.4209 65.75 53.9503 67.4353 53.2445C68.8853 52.6386 70.4618 52.6033 72.0382 53.1915C72.3294 53.3003 72.6206 53.4297 72.9088 53.5827L72.9118 53.5856C75.2382 54.8033 77.65 54.6356 79.697 53.2062C80.4147 52.7062 81.0882 52.0474 81.6971 51.2415L81.9206 50.9444C84.5118 47.515 88.2382 46.8621 91.5971 49.2503L91.8529 49.4327C92.3941 49.818 92.9441 50.1239 93.5 50.3503L116.839 73.6895Z",
    fill: "url(#paint32_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9507 58.3365C90.9478 58.3365 88.5137 60.7707 88.5137 63.7736C88.5137 66.7765 90.9478 69.2107 93.9507 69.2107C96.9534 69.2107 99.3878 66.7765 99.3878 63.7736C99.3878 60.7707 96.9537 58.3365 93.9507 58.3365ZM93.9507 66.0815C92.676 66.0815 91.6428 65.0483 91.6428 63.7736C91.6428 62.4989 92.676 61.4657 93.9507 61.4657C95.2254 61.4657 96.2587 62.4989 96.2587 63.7736C96.2587 65.0483 95.2254 66.0815 93.9507 66.0815Z",
    fill: "url(#paint33_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.625 60.3741C119.622 60.3741 117.188 62.8083 117.188 65.8112C117.188 68.8141 119.622 71.2483 122.625 71.2483C125.628 71.2483 128.062 68.8141 128.062 65.8112C128.062 62.8083 125.628 60.3741 122.625 60.3741ZM122.625 68.1191C121.351 68.1191 120.317 67.0859 120.317 65.8112C120.317 64.5365 121.351 63.5033 122.625 63.5033C123.9 63.5033 124.933 64.5365 124.933 65.8112C124.933 67.0859 123.9 68.1191 122.625 68.1191Z",
    fill: "url(#paint34_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62 45.6168C93.1132 45.3535 93.2997 44.7403 93.0365 44.2471C92.7732 43.7538 92.16 43.5674 91.6668 43.8306C91.1735 44.0938 90.987 44.7071 91.2503 45.2003C91.5135 45.6935 92.1268 45.88 92.62 45.6168Z",
    fill: "url(#paint35_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6352 44.0982C89.4273 43.7088 88.9432 43.5614 88.5538 43.7694C88.1644 43.9773 88.017 44.4614 88.2249 44.8509C88.4329 45.2403 88.917 45.3876 89.3064 45.1797C89.6958 44.9717 89.8429 44.4876 89.6352 44.0982Z",
    fill: "url(#paint36_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0355 48.0452C87.9102 47.8105 87.6184 47.7217 87.3834 47.847C87.1484 47.9723 87.0599 48.264 87.1852 48.499C87.3105 48.734 87.6022 48.8226 87.8372 48.6973C88.0719 48.5717 88.1608 48.2799 88.0355 48.0452Z",
    fill: "url(#paint37_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0229 53.0091C92.5682 52.6838 91.9358 52.7888 91.6105 53.2435C91.2853 53.6982 91.3903 54.3306 91.845 54.6559C92.2997 54.9812 92.932 54.8762 93.2573 54.4215C93.5826 53.9668 93.4776 53.3344 93.0229 53.0091Z",
    fill: "url(#paint38_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.393 50.0123C101.034 49.7556 100.535 49.8382 100.278 50.1973C100.021 50.5564 100.104 51.0556 100.463 51.3123C100.822 51.5691 101.321 51.4864 101.578 51.1273C101.835 50.7682 101.752 50.2691 101.393 50.0123Z",
    fill: "url(#paint39_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0646 46.1156C94.8481 45.9606 94.5472 46.0106 94.3922 46.2271C94.2375 46.4436 94.2872 46.7444 94.5037 46.8994C94.7202 47.0541 95.021 47.0044 95.176 46.788C95.331 46.5715 95.281 46.2706 95.0646 46.1156Z",
    fill: "url(#paint40_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4268 48.6702C91.0415 48.5211 90.6083 48.7129 90.4592 49.0982C90.31 49.4834 90.5018 49.9167 90.8871 50.0658C91.2724 50.2149 91.7056 50.0232 91.8547 49.6379C92.0039 49.2523 91.8121 48.819 91.4268 48.6702Z",
    fill: "url(#paint41_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2885 47.4059C92.9843 47.2882 92.6423 47.4397 92.5246 47.7438C92.407 48.0479 92.5585 48.39 92.8626 48.5076C93.1667 48.6253 93.5088 48.4738 93.6264 48.1697C93.7441 47.8653 93.5926 47.5235 93.2885 47.4059Z",
    fill: "url(#paint42_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6515 47.0229C90.8351 47.0938 91.0412 47.0026 91.1121 46.8191C91.183 46.6356 91.0918 46.4294 90.9083 46.3585C90.7248 46.2876 90.5186 46.3788 90.4477 46.5623C90.3768 46.7459 90.4683 46.952 90.6515 47.0229Z",
    fill: "url(#paint43_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.858 53.6223C110.351 53.359 110.538 52.7458 110.274 52.2526C110.011 51.7593 109.398 51.5729 108.905 51.8361C108.411 52.0993 108.225 52.7126 108.488 53.2058C108.751 53.699 109.365 53.8855 109.858 53.6223Z",
    fill: "url(#paint44_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.928 58.1055C100.72 57.7161 100.236 57.5688 99.8465 57.7767C99.4571 57.9846 99.3097 58.4688 99.5177 58.8582C99.7256 59.2476 100.21 59.3949 100.599 59.187C100.989 58.9791 101.136 58.4949 100.928 58.1055Z",
    fill: "url(#paint45_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.336 53.752C102.211 53.5173 101.919 53.4285 101.684 53.5538C101.45 53.6791 101.361 53.9708 101.486 54.2058C101.611 54.4405 101.903 54.5294 102.138 54.4041C102.373 54.2788 102.462 53.987 102.336 53.752Z",
    fill: "url(#paint46_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.668 57.8358C113.213 57.5105 112.581 57.6155 112.256 58.0702C111.93 58.5249 112.035 59.1572 112.49 59.4825C112.945 59.8078 113.577 59.7028 113.902 59.2481C114.228 58.7934 114.123 58.1611 113.668 57.8358Z",
    fill: "url(#paint47_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.33 56.6526C114.587 56.2935 114.504 55.7944 114.145 55.5376C113.786 55.2808 113.287 55.3635 113.03 55.7226C112.773 56.0817 112.856 56.5808 113.215 56.8376C113.574 57.0944 114.073 57.0114 114.33 56.6526Z",
    fill: "url(#paint48_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.302 54.1212C112.086 53.9665 111.785 54.0162 111.63 54.2327C111.475 54.4492 111.525 54.75 111.741 54.905C111.958 55.0598 112.259 55.01 112.414 54.7936C112.569 54.5771 112.519 54.2762 112.302 54.1212Z",
    fill: "url(#paint49_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.774 57.4826C104.389 57.3335 103.956 57.5252 103.807 57.9105C103.658 58.2958 103.849 58.7291 104.235 58.8782C104.62 59.0273 105.053 58.8355 105.202 58.4502C105.352 58.0649 105.16 57.6317 104.774 57.4826Z",
    fill: "url(#paint50_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.526 55.4114C110.222 55.2937 109.88 55.4449 109.763 55.7493C109.645 56.0534 109.796 56.3955 110.1 56.5131C110.405 56.6308 110.747 56.4793 110.864 56.1752C110.982 55.8711 110.83 55.529 110.526 55.4114Z",
    fill: "url(#paint51_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.889 55.0285C108.073 55.0994 108.279 55.0082 108.35 54.8247C108.421 54.6412 108.33 54.435 108.146 54.3641C107.963 54.2932 107.756 54.3844 107.686 54.568C107.615 54.7515 107.706 54.9577 107.889 55.0285Z",
    fill: "url(#paint52_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8963 71.4112C81.1793 77.1283 71.9213 77.1392 66.2178 71.4356C60.5143 65.7321 60.5254 56.4742 66.2422 50.7571C71.959 45.04 85.579 40.6674 91.2825 46.3709C96.986 52.0744 92.6134 65.6942 86.8963 71.4112Z",
    fill: "url(#paint53_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6527 70.8359C70.808 75.3856 79.1703 74.7273 84.6912 69.2062C90.1277 63.7697 94.7927 51.6344 90.8562 46.0762C90.7348 45.9044 90.5847 45.7535 90.4159 45.6279C84.3012 41.0882 71.6877 45.3118 66.2424 50.7571C60.7212 56.2779 60.5233 65.1006 65.6527 70.8359Z",
    fill: "url(#paint54_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7756 68.6286C78.3062 68.6286 81.9791 64.9558 81.9791 60.4251C81.9791 55.8944 78.3062 52.2216 73.7756 52.2216C69.2449 52.2216 65.572 55.8944 65.572 60.4251C65.572 64.9558 69.2449 68.6286 73.7756 68.6286Z",
    fill: "url(#paint55_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9617 76.2239C71.6473 76.2345 67.3285 76.183 63.0729 76.0713C62.0229 76.0436 60.977 73.9536 59.9355 73.9186C58.6967 73.8771 57.4649 75.8892 56.2414 75.8371C55.6143 75.8107 54.9896 75.7827 54.3676 75.7533C29.1793 74.5592 8.06756 71.1268 6.36462 65.4533C6.31462 65.1239 6.28227 64.7915 6.26756 64.4621C6.2058 63.2621 6.36756 62.0621 6.77638 60.8739C8.02638 57.2415 11.1529 54.9562 15.4323 53.768C16.9852 53.3357 18.6264 52.3327 20.2529 50.7651L20.4264 50.5945C23.9587 47.1827 27.4087 47.0739 29.2617 50.3121V50.3151C30.847 53.0827 33.6146 53.4386 36.6499 51.2651L36.9382 51.0592C40.2852 48.6621 43.2735 49.4004 44.694 52.9739L44.8029 53.2474C44.9411 53.5915 45.094 53.9121 45.2587 54.2033C46.6705 56.6915 49.0705 57.2504 51.7999 55.6562L52.0558 55.5062C55.3764 53.568 58.1852 54.8268 59.347 58.7768L59.4676 59.1886C59.7058 60.0004 60.0146 60.7004 60.3852 61.2827C61.6352 63.2533 63.5823 63.868 65.8529 62.9151C66.5588 62.618 67.2323 62.4739 67.8617 62.4739C70.3029 62.4739 72.0882 64.6415 72.6264 68.4915L72.6735 68.8151C72.9852 71.0533 73.6617 72.8533 74.6205 74.1504C75.1293 74.8357 75.5764 75.5298 75.9617 76.2239Z",
    fill: "url(#paint56_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.338 67.398C122.946 64.8971 119.343 63.6709 115.718 64.4765C110.771 65.5762 107.466 70.0868 107.722 74.9851C107.725 74.9848 107.727 74.9848 107.729 74.9845C107.778 74.9803 114.788 73.5656 118.094 73.1486C121.527 72.7153 125.032 72.9621 127.911 72.4086C128.605 72.2751 129.281 72.1383 129.938 71.9977L125.338 67.398Z",
    fill: "url(#paint57_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.925 72.2432C126.699 66.728 121.234 63.2506 115.718 64.4765C110.771 65.5762 107.466 70.0868 107.722 74.985C115.335 74.36 122.252 73.4988 127.951 72.4012C127.943 72.3485 127.936 72.2962 127.925 72.2432Z",
    fill: "url(#paint58_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66 73.7051C113.66 69.8954 110.571 66.8069 106.761 66.8069C102.951 66.8069 99.863 69.8954 99.863 73.7051C99.863 74.3328 99.9486 74.9404 100.105 75.5184C104.831 75.2401 109.368 74.8781 113.621 74.4354C113.646 74.1951 113.66 73.9519 113.66 73.7051Z",
    fill: "url(#paint59_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1041 66.6554C55.41 63.9613 52.0503 62.6907 48.6114 62.0745C43.0335 61.0754 37.1432 62.4133 32.7735 66.783C30.7976 68.7589 29.1264 70.9504 28.2559 73.421C28.4691 73.4521 28.6885 73.4816 28.9038 73.5121C28.9035 73.5127 28.9032 73.5133 28.9032 73.5139C36.3212 74.5657 45.0656 75.3121 54.3676 75.7533C54.9841 75.7824 55.6032 75.8101 56.2244 75.8366C57.4662 75.8892 58.7167 74.466 59.9744 74.508C61.0003 74.5424 62.0309 76.0436 63.065 76.0707C64.572 76.1101 66.0867 76.1421 67.6067 76.1665L58.1041 66.6554Z",
    fill: "url(#paint60_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8685 58.3365C27.8655 58.3365 25.4314 60.7707 25.4314 63.7736C25.4314 66.7765 27.8655 69.2107 30.8685 69.2107C33.8711 69.2107 36.3055 66.7765 36.3055 63.7736C36.3055 60.7707 33.8714 58.3365 30.8685 58.3365ZM30.8685 66.0815C29.5938 66.0815 28.5605 65.0483 28.5605 63.7736C28.5605 62.4989 29.5938 61.4657 30.8685 61.4657C32.1432 61.4657 33.1764 62.4989 33.1764 63.7736C33.1764 65.0483 32.1432 66.0815 30.8685 66.0815Z",
    fill: "url(#paint61_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.104 66.6553C51.0405 59.5918 39.5878 59.5918 32.524 66.6553C30.5481 68.6312 29.1261 70.9506 28.2555 73.4209C30.4114 73.735 32.6834 74.023 35.0528 74.2844C35.5899 73.2168 36.3008 72.2144 37.192 71.3233C41.677 66.8383 48.949 66.84 53.434 71.325C54.7452 72.6362 55.7484 73.895 56.2931 75.5433C57.5246 75.5956 58.6861 75.9339 59.9329 75.9756C60.9784 76.0106 62.029 76.0421 63.0837 76.0697C62.4323 72.6209 60.7734 69.3247 58.104 66.6553Z",
    fill: "url(#paint62_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9532 68.8065C50.0764 62.9297 40.552 62.9297 34.6752 68.8065C33.1902 70.2915 32.0817 72.0103 31.3473 73.8442C32.5526 73.9986 33.7896 74.1453 35.0532 74.2847C35.5899 73.2171 36.3011 72.2147 37.1923 71.3236C41.6773 66.8386 48.9511 66.8386 53.4361 71.3236C54.7476 72.635 55.6726 74.1856 56.217 75.8344C57.4552 75.8871 58.7005 75.9353 59.9546 75.9774C59.3346 73.3495 58.0023 70.8556 55.9532 68.8065Z",
    fill: "url(#paint63_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0657 44.5901C48.2578 44.0651 47.9881 43.4836 47.4628 43.2913C46.9378 43.0992 46.3563 43.3689 46.164 43.8942C45.9719 44.4192 46.2416 45.0007 46.7669 45.1927C47.2922 45.3851 47.8737 45.1154 48.0657 44.5901Z",
    fill: "url(#paint64_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8287 45.4483C44.4143 45.2966 43.9552 45.5098 43.8034 45.9242C43.6517 46.3386 43.8649 46.7977 44.2793 46.9495C44.6937 47.1013 45.1528 46.888 45.3046 46.4736C45.4564 46.0589 45.2431 45.5998 44.8287 45.4483Z",
    fill: "url(#paint65_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.268 49.4566C46.018 49.3651 45.7412 49.4937 45.6497 49.7437C45.5582 49.9937 45.6868 50.2704 45.9365 50.3619C46.1862 50.4534 46.4632 50.3248 46.5547 50.0751C46.6462 49.8248 46.5177 49.5481 46.268 49.4566Z",
    fill: "url(#paint66_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2944 49.8313C52.7385 49.8919 52.3371 50.3919 52.3979 50.9478C52.4585 51.5037 52.9585 51.9051 53.5144 51.8442C54.0703 51.7837 54.4718 51.2837 54.4109 50.7278C54.35 50.1719 53.8503 49.7704 53.2944 49.8313Z",
    fill: "url(#paint67_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5347 42.0171C57.0959 42.0651 56.7791 42.4595 56.8271 42.8983C56.875 43.3371 57.2694 43.6539 57.7082 43.6059C58.1471 43.558 58.4638 43.1633 58.4159 42.7248C58.3679 42.2862 57.9735 41.9692 57.5347 42.0171Z",
    fill: "url(#paint68_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2205 43.3322C49.9558 43.361 49.7649 43.599 49.7938 43.8637C49.8226 44.1281 50.0605 44.3193 50.3252 44.2905C50.5897 44.2616 50.7808 44.0237 50.752 43.759C50.7229 43.4943 50.485 43.3034 50.2205 43.3322Z",
    fill: "url(#paint69_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2126 47.6613C48.8262 47.8072 48.6309 48.2389 48.777 48.6254C48.9229 49.0119 49.3547 49.2072 49.7412 49.0613C50.1276 48.9154 50.3229 48.4836 50.177 48.0972C50.0311 47.7107 49.5991 47.5154 49.2126 47.6613Z",
    fill: "url(#paint70_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7566 45.4778C49.4514 45.5931 49.2975 45.9337 49.4125 46.239C49.5278 46.5443 49.8684 46.6981 50.1737 46.5831C50.479 46.4678 50.6328 46.1272 50.5178 45.8219C50.4028 45.5167 50.0619 45.3628 49.7566 45.4778Z",
    fill: "url(#paint71_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5359 46.9507C47.7201 46.8813 47.8127 46.6757 47.7433 46.4919C47.6739 46.3078 47.4683 46.2151 47.2845 46.2845C47.1004 46.3539 47.0077 46.5595 47.0771 46.7433C47.1465 46.9272 47.3518 47.0201 47.5359 46.9507Z",
    fill: "url(#paint72_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2509 39.0642C66.443 38.5392 66.1733 37.9578 65.648 37.7654C65.123 37.5733 64.5415 37.843 64.3491 38.3683C64.1571 38.8933 64.4268 39.4748 64.9521 39.6672C65.4774 39.8592 66.0588 39.5895 66.2509 39.0642Z",
    fill: "url(#paint73_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5845 48.3588C62.17 48.2071 61.7109 48.4203 61.5592 48.8347C61.4074 49.2491 61.6206 49.7083 62.035 49.86C62.4495 50.0118 62.9086 49.7986 63.0603 49.3841C63.2118 48.9697 62.9989 48.5106 62.5845 48.3588Z",
    fill: "url(#paint74_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7317 44.1757C60.4817 44.0842 60.2049 44.2128 60.1135 44.4628C60.022 44.7128 60.1505 44.9895 60.4002 45.0807C60.6502 45.1722 60.927 45.0437 61.0185 44.7939C61.1099 44.5437 60.9814 44.2669 60.7317 44.1757Z",
    fill: "url(#paint75_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8999 39.6646C71.344 39.7251 70.9425 40.2251 71.0034 40.781C71.064 41.3369 71.564 41.7384 72.1199 41.6775C72.6758 41.6169 73.0772 41.1169 73.0163 40.561C72.9555 40.0051 72.4558 39.6037 71.8999 39.6646Z",
    fill: "url(#paint76_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6044 38.341C71.5564 37.9022 71.1617 37.5854 70.7232 37.6333C70.2844 37.6813 69.9676 38.0757 70.0155 38.5145C70.0635 38.9533 70.4579 39.2701 70.8967 39.2222C71.3355 39.1745 71.6523 38.7798 71.6044 38.341Z",
    fill: "url(#paint77_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4056 37.8063C68.1412 37.8352 67.95 38.0731 67.9788 38.3378C68.0077 38.6022 68.2456 38.7934 68.5103 38.7646C68.7747 38.7358 68.9659 38.4978 68.9371 38.2331C68.9079 37.9684 68.6703 37.7775 68.4056 37.8063Z",
    fill: "url(#paint78_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.036 45.3305C64.6495 45.4764 64.4542 45.9081 64.6001 46.2946C64.746 46.6811 65.1778 46.8764 65.5642 46.7305C65.9507 46.5846 66.146 46.1528 65.9998 45.7663C65.8542 45.3799 65.4225 45.1846 65.036 45.3305Z",
    fill: "url(#paint79_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9421 39.9522C67.6368 40.0675 67.4829 40.4081 67.5979 40.7134C67.7132 41.0187 68.0538 41.1725 68.3591 41.0575C68.6644 40.9422 68.8182 40.6016 68.7032 40.2963C68.5879 39.991 68.2471 39.8369 67.9421 39.9522Z",
    fill: "url(#paint80_linear_465_7549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.721 41.4248C65.9051 41.3554 65.9978 41.1498 65.9284 40.966C65.8589 40.7819 65.6534 40.6892 65.4695 40.7586C65.2854 40.8281 65.1928 41.0336 65.2622 41.2175C65.3316 41.4013 65.5372 41.4942 65.721 41.4248Z",
    fill: "url(#paint81_linear_465_7549)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_7549",
    x1: 75.3675,
    y1: 112.749,
    x2: 75.9166,
    y2: 121.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_7549",
    x1: 63.5971,
    y1: 53.2797,
    x2: 103.684,
    y2: 113.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_7549",
    x1: 65.9477,
    y1: 27.9224,
    x2: 76.5359,
    y2: 70.6677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_7549",
    x1: 77.061,
    y1: 28.9103,
    x2: 77.061,
    y2: 49.8062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_7549",
    x1: 110.021,
    y1: 41.5185,
    x2: 113.257,
    y2: 47.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_7549",
    x1: 68.162,
    y1: 31.0809,
    x2: 71.3973,
    y2: 37.5515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_7549",
    x1: 102.697,
    y1: 41.3824,
    x2: 102.697,
    y2: 52.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_7549",
    x1: 69.1092,
    y1: 58.0138,
    x2: 63.5863,
    y2: 25.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_7549",
    x1: 75.0588,
    y1: 94.1462,
    x2: 75.0588,
    y2: -12.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_7549",
    x1: 99.9807,
    y1: 96.7033,
    x2: 112.15,
    y2: 104.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_7549",
    x1: 97.1591,
    y1: 53.7685,
    x2: 99.1123,
    y2: 76.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_7549",
    x1: 61.163,
    y1: 30.715,
    x2: 53.9595,
    y2: 51.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_7549",
    x1: 51.394,
    y1: 59.3437,
    x2: 57.386,
    y2: 41.8567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_7549",
    x1: 121.669,
    y1: 40.4021,
    x2: 129.487,
    y2: 56.3698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_7549",
    x1: 141.657,
    y1: 66.43,
    x2: 123.122,
    y2: 47.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_7549",
    x1: 87.1416,
    y1: 33.4574,
    x2: 83.5838,
    y2: 39.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_7549",
    x1: 79.3769,
    y1: 38.4768,
    x2: 77.6835,
    y2: 41.1609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_7549",
    x1: 88.1285,
    y1: 38.415,
    x2: 86.4351,
    y2: 41.0991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_7549",
    x1: 93.5404,
    y1: 35.8145,
    x2: 91.8471,
    y2: 38.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_7549",
    x1: 79.9541,
    y1: 40.5666,
    x2: 77.3249,
    y2: 44.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_7549",
    x1: 83.3453,
    y1: 36.1839,
    x2: 81.2697,
    y2: 39.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_7549",
    x1: 90.6416,
    y1: 33.2433,
    x2: 88.5657,
    y2: 36.5334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_7549",
    x1: 85.1972,
    y1: 37.8381,
    x2: 83.9458,
    y2: 39.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_7549",
    x1: 83.4155,
    y1: 38.0245,
    x2: 77.2629,
    y2: 55.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_7549",
    x1: 75.0737,
    y1: 62.4887,
    x2: 80.1913,
    y2: 47.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_7549",
    x1: 42.6071,
    y1: 41.0665,
    x2: 45.8364,
    y2: 58.4075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_7549",
    x1: 118.349,
    y1: 35.1631,
    x2: 111.145,
    y2: 56.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_7549",
    x1: 108.58,
    y1: 63.7917,
    x2: 114.572,
    y2: 46.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_7549",
    x1: 29.1674,
    y1: 40.0925,
    x2: 23.0188,
    y2: 58.0364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_7549",
    x1: 20.8305,
    y1: 64.5415,
    x2: 25.9451,
    y2: 49.6155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_7549",
    x1: 97.1588,
    y1: 53.768,
    x2: 99.1123,
    y2: 76.6218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_7549",
    x1: 109.474,
    y1: 65.2748,
    x2: 108.592,
    y2: 29.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_7549",
    x1: 96.1374,
    y1: 79.2627,
    x2: 66.4094,
    y2: 55.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_7549",
    x1: 91.1151,
    y1: 58.1021,
    x2: 94.3504,
    y2: 64.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_7549",
    x1: 119.79,
    y1: 60.1397,
    x2: 123.025,
    y2: 66.6103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_7549",
    x1: 92.0909,
    y1: 43.1114,
    x2: 91.5873,
    y2: 47.8768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_7549",
    x1: 88.8438,
    y1: 43.1834,
    x2: 88.4459,
    y2: 46.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_7549",
    x1: 87.4717,
    y1: 47.4606,
    x2: 87.2319,
    y2: 49.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_7549",
    x1: 92.3774,
    y1: 52.2199,
    x2: 91.8736,
    y2: 56.9855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_7549",
    x1: 100.838,
    y1: 49.376,
    x2: 100.441,
    y2: 53.1383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_7549",
    x1: 94.6461,
    y1: 45.6995,
    x2: 94.4063,
    y2: 47.9678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_7549",
    x1: 91.0605,
    y1: 48.1549,
    x2: 90.6881,
    y2: 51.6766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_7549",
    x1: 92.9542,
    y1: 46.9831,
    x2: 92.6602,
    y2: 49.7634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_7549",
    x1: 90.6216,
    y1: 46.0714,
    x2: 90.4445,
    y2: 47.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_7549",
    x1: 109.324,
    y1: 51.1239,
    x2: 108.821,
    y2: 55.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_7549",
    x1: 100.13,
    y1: 57.195,
    x2: 99.7323,
    y2: 60.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_7549",
    x1: 101.77,
    y1: 53.1738,
    x2: 101.53,
    y2: 55.4417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_7549",
    x1: 113.02,
    y1: 57.0553,
    x2: 112.516,
    y2: 61.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_7549",
    x1: 113.587,
    y1: 54.9064,
    x2: 113.19,
    y2: 58.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_7549",
    x1: 111.88,
    y1: 53.7122,
    x2: 111.64,
    y2: 55.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_7549",
    x1: 104.403,
    y1: 56.9729,
    x2: 104.032,
    y2: 60.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_7549",
    x1: 110.188,
    y1: 54.9956,
    x2: 109.894,
    y2: 57.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_7549",
    x1: 107.855,
    y1: 54.084,
    x2: 107.678,
    y2: 55.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_7549",
    x1: 78.3419,
    y1: 58.8094,
    x2: 83.8934,
    y2: 76.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_7549",
    x1: 77.7821,
    y1: 59.4532,
    x2: 93.0733,
    y2: 131.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFDCFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#E9D6F7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#C5B5DE",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#AA9BCB",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688BD",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8A7DB5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_7549",
    x1: 68.8123,
    y1: 55.3116,
    x2: 81.6688,
    y2: 68.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#FFD643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#FFCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7826,
    stopColor: "#FFBB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    stopColor: "#FFA426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_7549",
    x1: 41.2711,
    y1: 62.9633,
    x2: 40.8787,
    y2: 80.0221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_465_7549",
    x1: 127.841,
    y1: 82.5003,
    x2: 113.085,
    y2: 67.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_465_7549",
    x1: 114.062,
    y1: 65.6044,
    x2: 117.515,
    y2: 72.6568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_465_7549",
    x1: 105.203,
    y1: 69.3434,
    x2: 107.738,
    y2: 76.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#FF8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#FF6C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_465_7549",
    x1: 47.922,
    y1: 76.4121,
    x2: 47.9935,
    y2: 63.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_465_7549",
    x1: 28.0329,
    y1: 58.1021,
    x2: 31.2682,
    y2: 64.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_465_7549",
    x1: 40.2426,
    y1: 62.923,
    x2: 46.4208,
    y2: 75.5427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_465_7549",
    x1: 50.0588,
    y1: 77.7336,
    x2: 34.5211,
    y2: 62.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_465_7549",
    x1: 46.2134,
    y1: 42.9922,
    x2: 49.0169,
    y2: 46.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_465_7549",
    x1: 43.8423,
    y1: 45.2119,
    x2: 46.0552,
    y2: 48.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_465_7549",
    x1: 45.673,
    y1: 49.3142,
    x2: 47.0074,
    y2: 51.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_465_7549",
    x1: 52.5027,
    y1: 49.5875,
    x2: 55.3062,
    y2: 53.4742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_465_7549",
    x1: 56.9094,
    y1: 41.8248,
    x2: 59.1229,
    y2: 44.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_465_7549",
    x1: 49.8438,
    y1: 43.216,
    x2: 51.1779,
    y2: 45.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_465_7549",
    x1: 48.8103,
    y1: 47.4375,
    x2: 50.882,
    y2: 50.3098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_465_7549",
    x1: 49.4393,
    y1: 45.3011,
    x2: 51.0749,
    y2: 47.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_465_7549",
    x1: 47.093,
    y1: 46.1778,
    x2: 48.0792,
    y2: 47.5448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_465_7549",
    x1: 64.3986,
    y1: 37.4663,
    x2: 67.2021,
    y2: 41.3528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_465_7549",
    x1: 61.5977,
    y1: 48.1227,
    x2: 63.8109,
    y2: 51.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_465_7549",
    x1: 60.137,
    y1: 44.0331,
    x2: 61.4711,
    y2: 45.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_465_7549",
    x1: 71.1081,
    y1: 39.4207,
    x2: 73.9117,
    y2: 43.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_465_7549",
    x1: 70.0979,
    y1: 37.441,
    x2: 72.3114,
    y2: 40.5092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_465_7549",
    x1: 68.0288,
    y1: 37.6905,
    x2: 69.3632,
    y2: 39.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_465_7549",
    x1: 64.6337,
    y1: 45.1066,
    x2: 66.7054,
    y2: 47.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_465_7549",
    x1: 67.6244,
    y1: 39.7754,
    x2: 69.26,
    y2: 42.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_465_7549",
    x1: 65.2781,
    y1: 40.6519,
    x2: 66.2642,
    y2: 42.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_7549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.0588379 0.0159912)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategorySalads);
export default __webpack_public_path__ + "static/media/icon-category-salads.f22e7f4a.svg";
export { ForwardRef as ReactComponent };